import { EXERCISE_LIBRARY } from "../constants";

export const slugifyExerciseName = (name) =>
  (name || "")
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/[\s-]+/g, "_")
    .replace(/^_+|_+$/g, "");

// Find a library entry by id (preferred) or name (fallback)
export const findLibraryEntry = (idOrRef) => {
  if (!idOrRef) return null;
  const id   = typeof idOrRef === "string" ? idOrRef : idOrRef.id;
  const name = typeof idOrRef === "string" ? null    : idOrRef.name;
  if (id) {
    const byId = EXERCISE_LIBRARY.find(e => e.id === id);
    if (byId) return byId;
  }
  if (name) {
    const lower = name.toLowerCase();
    return EXERCISE_LIBRARY.find(e => e.name.toLowerCase() === lower) || null;
  }
  return null;
};

// Resolve a full exercise object (library/custom + override) for editing or lookup.
// Returns shape suitable for CustomExerciseModal (with isCustom + hasOverride flags).
export const resolveExercise = (ref, customExercises = [], overrides = {}) => {
  const id    = ref?.id || ref?.exerciseId || null;
  const name  = ref?.name || "";
  const lower = name.toLowerCase();

  const custom = customExercises.find(c =>
    (id && c.id === id) || (lower && c.name?.toLowerCase() === lower)
  );
  if (custom) {
    const ov = overrides[custom.id] || overrides[lower] || {};
    return { ...custom, ...ov, isCustom: true };
  }

  const lib = findLibraryEntry({ id, name });
  if (lib) {
    const ov = overrides[lib.id] || overrides[lib.name.toLowerCase()];
    return { ...lib, ...(ov || {}), isCustom: false, hasOverride: !!ov };
  }
  return null;
};

// Resolve progression direction ("up" | "down") for an exercise, preferring custom data over library, defaulting to "up"
export const resolveProgressionDirection = (ref, customExercises = []) => {
  const id   = ref?.id || ref?.exerciseId || null;
  const name = ref?.name || "";
  const lower = name.toLowerCase();
  const custom = customExercises.find(c =>
    (id && c.id === id) || (lower && c.name?.toLowerCase() === lower)
  );
  if (custom?.progressionDirection) return custom.progressionDirection;
  const lib = findLibraryEntry({ id, name });
  if (lib?.progressionDirection) return lib.progressionDirection;
  return "up";
};

// Read an override entry, preferring id-keyed but falling back to name-keyed (legacy)
export const lookupOverride = (overrides, exerciseId, name) => {
  if (!overrides) return null;
  if (exerciseId && overrides[exerciseId]) return overrides[exerciseId];
  if (name) {
    // Plan exercises predating the id migration carry no exerciseId — resolve name → library id
    const lib = findLibraryEntry({ name });
    if (lib && overrides[lib.id]) return overrides[lib.id];
    // Legacy name-keyed (lowercased) override
    if (overrides[name.toLowerCase()]) return overrides[name.toLowerCase()];
  }
  return null;
};
